import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { Dropdown, Space, Switch, Table } from "antd";
import TableAntd from "components/elements/Table/Table";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
const DeductionTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onEdit = () => { },
  onDelete = () => { },
  onStatus = () => { },
  onChange = () => { },
}) => {
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  const columns = [
    {
      title: <div className="text-table">{t("deduction.label.code")}</div>,
      dataIndex: "code",
      key: "code",
      align: "center",
    },
    {
      title: <div className="text-table">{t("deduction.label.name")}</div>,
      dataIndex: "income",
      key: "income",
      render: (_, record) => {
        if (i18n.language === "en") {
          return record?.nameEn;
        }
        return record?.name;
      },
    },
    {
      title: <div className="text-table">{t("deduction.label.type")}</div>,
      dataIndex: "incomeType",
      key: "incomeType",
      render: (_, record) => {
        const { incomeType = {} } = record;
        if (i18n.language === "en") {
          return incomeType?.nameEn;
        }
        return incomeType?.name;
      },
    },
    {
      title: (
        <div className="text-table">{t("deduction.label.tax_calculation")}</div>
      ),
      dataIndex: "taxCalculation",
      key: "taxCalculation",
      render: (_, record) => {
        const { taxCalculation = {} } = record;
        if (i18n.language === "en") {
          return taxCalculation?.nameEn;
        }
        return taxCalculation?.name;
      },
    },
    {
      title: (
        <div className="text-table">{t("deduction.label.off_period")}</div>
      ),
      dataIndex: "offPeriod",
      key: "offPeriod",
    },
    {
      title: (
        <div className="text-table">{t("deduction.label.previous_period")}</div>
      ),
      dataIndex: "previousPeriod",
      key: "previousPeriod",
    },
    {
      title: <div className="text-table">{t("deduction.label.do_pay")}</div>,
      dataIndex: "do_pay",
      key: "do_pay",
      render: () => "-",
    },
    // {
    //   title: (
    //     <div className="text-table">{t("deduction.label.account_group")}</div>
    //   ),
    //   dataIndex: "accountGroup",
    //   key: "accountGroup",
    // },
    {
      title: <div className="text-table">{t("deduction.label.calculate")}</div>,
      dataIndex: "calculate",
      key: "calculate",
      render: () => "-",
    },
    {
      title: <div className="text-table">{t("deduction.label.welfare")}</div>,
      dataIndex: "welfare",
      key: "welfare",
      render: () => "-",
    },
    {
      title: <div className="text-table">{t("deduction.label.status")}</div>,
      dataIndex: "statusFlag",
      key: "statusFlag",
      render: (text, record) => (
        <Switch
          checked={text === "ACTIVE"}
          onChange={(checked) => onStatus(checked, record)}
          disabled={roles.includes("UPDATE_CONFIGURATION|PAYROLL_SETTING|DEDUCTION") ? false : true}
        />
      ),
    },
    roles.includes("UPDATE_CONFIGURATION|PAYROLL_SETTING|DEDUCTION") ? {
      title: "",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                roles.includes("UPDATE_CONFIGURATION|PAYROLL_SETTING|DEDUCTION") && {
                  key: "1",
                  onClick: () => onEdit(record),
                  label: `${t("action.edit")}`,
                  icon: (
                    <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
                // {
                //   key: "2",
                //   label: (
                //     // eslint-disable-next-line jsx-a11y/anchor-is-valid
                //     <a
                //       href="#"
                //       onClick={(e) => {
                //         e.preventDefault();
                //         onDelete(record);
                //       }}
                //       style={{ color: "grey", fontSize: "14px" }}
                //     >
                //       {t("action.delete")}
                //     </a>
                //   ),
                //   icon: (
                //     <DeleteOutlined
                //       style={{ fontSize: "18px", color: "gray" }}
                //     />
                //   ),
                // },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    } : {},
  ];

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={dataSource}
      columns={columns}
      onChange={onChange}
      scroll={{ x: true }}
    />
  );
};

export default DeductionTable;
